import React from 'react';
import './SeatingMapWidget.css';
import templates from './templates';
import { migrateMapData } from './seatingMapUtils';

export const SeatingMapWidget = ({
  mapData,
  template = 'Classic',
  title = 'מפת מושבים',
  showTitle = true,
}) => {
  const TemplateComponent = templates[template] || templates.Classic;
  const data = migrateMapData(mapData);

  return (
    <TemplateComponent
      mapData={data}
      title={title}
      showTitle={showTitle}
    />
  );
};
